const CURRENCY_SIGN = {
  jpy: '¥',
  usd: '$'
};

const CURRENCY_DIGITS = {
  jpy: 0,
  usd: 2
};

export const Currency = {
  methods: {
    addFigure(num, digitCount) {
      if (typeof num === 'undefined') {
        num = 0;
      }
      if (typeof digitCount === 'undefined') {
        digitCount = null;
      }
      if (digitCount === null) {
        num = num + '';
      } else {
        num = (num - 0).toFixed(digitCount);
      }
      while (num !== (num = num.replace(/^(-?)(\d+)(\d{3})/, '$1$2,$3')));
      return num;
    },

    getCurrencySign(currency) {
      return CURRENCY_SIGN[currency] || '';
    },

    formatCurrency(value, currency) {
      return `${this.getCurrencySign(currency)}${this.addFigure(
        value,
        CURRENCY_DIGITS[currency] || 0
      )}`;
    }
  }
};
